/** Categorias de anexo aceitas pela API de contas a pagar (query param `category`). */
export enum AccountsPayableAttachmentCategory {
  Comprovante = 'Comprovante',
  NotaFiscal = 'Nota Fiscal',
  Boleto = 'Boleto',
  Fatura = 'Fatura',
  Recibo = 'Recibo',
  Contrato = 'Contrato',
  ExtratoBancario = 'Extrato Bancário',
  OrdemPagamento = 'Ordem de Pagamento',
  Imposto = 'Imposto / Guia',
  Outros = 'Outros'
}

export interface AccountsPayableAttachmentCategoryOption {
  value: AccountsPayableAttachmentCategory;
  label: string;
}

export const ACCOUNTS_PAYABLE_ATTACHMENT_CATEGORIES: AccountsPayableAttachmentCategoryOption[] = [
  { value: AccountsPayableAttachmentCategory.Comprovante, label: 'Comprovante de pagamento' },
  { value: AccountsPayableAttachmentCategory.NotaFiscal, label: 'Nota fiscal' },
  { value: AccountsPayableAttachmentCategory.Boleto, label: 'Boleto' },
  { value: AccountsPayableAttachmentCategory.Fatura, label: 'Fatura' },
  { value: AccountsPayableAttachmentCategory.Recibo, label: 'Recibo' },
  { value: AccountsPayableAttachmentCategory.Contrato, label: 'Contrato' },
  { value: AccountsPayableAttachmentCategory.ExtratoBancario, label: 'Extrato bancário' },
  { value: AccountsPayableAttachmentCategory.OrdemPagamento, label: 'Ordem de pagamento' },
  { value: AccountsPayableAttachmentCategory.Imposto, label: 'Imposto / guia' },
  { value: AccountsPayableAttachmentCategory.Outros, label: 'Outros' }
];

export const DEFAULT_ACCOUNTS_PAYABLE_ATTACHMENT_CATEGORY =
  AccountsPayableAttachmentCategory.Comprovante;
